import { useEffect, useState } from "react";
import { LATIDO_MS, TTL_MS } from "./pantallaAparte";

// «Pantalla aparte del chat»: UNA ventana con varios chats. Mismo mecanismo que la pantalla aparte del Centro de Llamadas
// (latido en localStorage con caducidad), pero con claves propias para no mezclarse con aquella.
export const APARTE_LATIDO_KEY = "tg.aparte.latido";
export const APARTE_CERRAR_KEY = "tg.aparte.cerrar";
export const APARTE_ADD_KEY = "tg.aparte.add";
export const APARTE_ABIERTAS_KEY = "tg.aparte.abiertas";
export const APARTE_NOMBRE = "commandix-chat-aparte";

export function aparteAbierta(now = Date.now()) {
  try {
    const t = Number(localStorage.getItem(APARTE_LATIDO_KEY));
    return Number.isFinite(t) && t > 0 && now - t < TTL_MS && now - t > -TTL_MS;
  } catch (e) { return false; }
}

/** La usa la ventana aparte: late mientras exista; `onCerrar` = alguien pidió cerrarla; `onAgregar(id)` = otra ventana le manda un chat. */
export function useAparteLatido(onCerrar, onAgregar) {
  useEffect(() => {
    const beat = () => { try { localStorage.setItem(APARTE_LATIDO_KEY, String(Date.now())); } catch (e) { /* sin almacenamiento */ } };
    const gone = () => { try { localStorage.removeItem(APARTE_LATIDO_KEY); } catch (e) { /* ignorar */ } };
    const onStorage = (e) => {
      if (e.key === APARTE_CERRAR_KEY && e.newValue) onCerrar?.();
      if (e.key === APARTE_ADD_KEY && e.newValue) {
        try { const v = JSON.parse(e.newValue); if (v?.id) onAgregar?.(String(v.id)); } catch (err) { /* mensaje ajeno */ }
      }
    };
    beat();
    const id = setInterval(beat, LATIDO_MS);
    window.addEventListener("pagehide", gone);
    window.addEventListener("storage", onStorage);
    return () => { clearInterval(id); window.removeEventListener("pagehide", gone); window.removeEventListener("storage", onStorage); gone(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function useAparteAbierta() {
  const [open, setOpen] = useState(() => aparteAbierta());
  useEffect(() => {
    const check = () => setOpen(aparteAbierta());
    const id = setInterval(check, 1000);
    const onStorage = (e) => { if (e.key === APARTE_LATIDO_KEY || e.key === null) check(); };
    window.addEventListener("storage", onStorage);
    check();
    return () => { clearInterval(id); window.removeEventListener("storage", onStorage); };
  }, []);
  return open;
}

/** Manda un chat (referencia «dueño::chat») a la pantalla aparte: si ya hay una abierta lo suma; si no, abre la ventana con ese chat. */
export function enviarChatAAparte(ref) {
  const id = String(ref || "");
  if (aparteAbierta()) {
    if (!id) return true;
    try { localStorage.setItem(APARTE_ADD_KEY, JSON.stringify({ id, t: Date.now() })); localStorage.removeItem(APARTE_ADD_KEY); return true; } catch (e) { /* cae a abrir ventana */ }
  }
  const w = Math.max(900, Math.round((window.screen?.availWidth || 1280) * 0.7));
  const h = Math.max(600, Math.round((window.screen?.availHeight || 800) * 0.8));
  window.open(id ? `/chat-aparte?add=${encodeURIComponent(id)}` : "/chat-aparte", APARTE_NOMBRE, `popup=yes,width=${w},height=${h},left=60,top=60`);
  return true;
}

export function pedirCerrarAparte() {
  try { localStorage.setItem(APARTE_CERRAR_KEY, String(Date.now())); localStorage.removeItem(APARTE_CERRAR_KEY); } catch (e) { /* ignorar */ }
}

export function leerAbiertas() {
  try { const v = JSON.parse(localStorage.getItem(APARTE_ABIERTAS_KEY) || "[]"); return Array.isArray(v) ? v.filter((x) => typeof x === "string").slice(0, 12) : []; } catch (e) { return []; }
}
export function guardarAbiertas(ids) {
  try { localStorage.setItem(APARTE_ABIERTAS_KEY, JSON.stringify((ids || []).slice(0, 12))); } catch (e) { /* ignorar */ }
}
